let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("z3s9q")).then(() => parcelRequire('9mYoH'));